import { defectFeaturesPath } from '../contracts/httpPaths';
import { DefectFeaturesResponseBody } from '../contracts/defectFeatures';
import { getRefreshDataHeader } from 'utils/getRefreshDataHeader';

import { surveyDataManagerClient, toSurveyDataManagerApiError } from './httpClient';
import {
  buildMockScannerFeatures,
  isMockScannerDefectSlug,
  isScannerMockCatalogueEnabled,
} from './scannerMockResponses';

export async function getDefectFeatures(
  slug: string,
  measurement: string,
  surveyYear: string,
  lane?: string,
  refreshData: boolean = false,
): Promise<DefectFeaturesResponseBody> {
  if (isScannerMockCatalogueEnabled() && isMockScannerDefectSlug(slug)) {
    const mocked = buildMockScannerFeatures(slug, measurement, surveyYear, lane);
    if (mocked) {
      return mocked;
    }
  }

  try {
    const params: { measurement: string; surveyYear: string; lane?: string } = {
      measurement,
      surveyYear,
    };
    if (lane) {
      params.lane = lane;
    }
    const response = await surveyDataManagerClient.get<DefectFeaturesResponseBody>(
      defectFeaturesPath(slug),
      {
        ...getRefreshDataHeader(refreshData),
        params,
      },
    );
    return response.data;
  } catch (error) {
    throw toSurveyDataManagerApiError(error);
  }
}
